import { PlusIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useNavigate, useParams } from 'react-router-dom'
import Funnel from '@/components/funnel'
import { ArrowRightIcon, SettingsIcon } from '@/components/icons'

const EmptyWizard = () => {
    const navigate = useNavigate()
    const { id } = useParams()

    const navigateToSettings = () => {
        navigate(`/campaigns/media-buying/${id}/settings/ad-account`, { replace: true })
    }

    return (
        <div className="campaigns-container tw:rounded-sm h-100 d-flex flex-column">
            <div className="tw:border-b tw:border-border tw:flex tw:!items-center tw:px-6 tw:py-4 tw:gap-2">
                <PlusIcon size={24} className="tw:text-gray-200" />
                <h2 className="tw:dark:text-white tw:text-black tw:!text-[20px] tw:font-medium tw:!m-0 tw:!mb-0">
                    New Ad Campaign
                </h2>
            </div>
            <div className="d-flex flex-grow-1 overflow-hidden">
                <nav className="tw:min-w-[240px] tw:max-w-[240px] tw:border-r tw:border-border tw:px-3 tw:py-4">
                    <div className="tw:!bg-[#6980AA29] tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark tw:outline-[2px] tw:rounded-lg tw:outline-blue-500 tw:!bg-[#6980AA29] tw:cursor-pointer">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Campaign Objective</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Location Targeting</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Sales Funnel Setup</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark d-none">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-6">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Attach Audience</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Audience Targeting</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Ads Selection</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Budget &amp; Schedule</span>
                        </div>
                    </div>
                    <div></div>
                    <div className="tw:!bg-transparent tw:text-[13px] tw:gap-3 tw:py-1.5 tw:my-1 dark">
                        <div className="tw:flex tw:items-center tw:gap-3 tw:!pt-0 tw:relative tw:ml-3">
                            <span className="tw:border-2 tw:border-gray-200 tw:rounded-full tw:size-4 tw:min-h-4 tw:min-w-4"></span>
                            <span>Review &amp; Launch</span>
                        </div>
                    </div>
                    <div></div>
                </nav>
                <div className="tw:flex tw:justify-between tw:w-full">
                    <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:w-44 tw:flex-1">
                        <div className="tw:p-4 tw:rounded-full tw:bg-[#2B3B4C] tw:mb-5">
                            <SettingsIcon size={56} />
                        </div>
                        <p className="tw:text-center tw:text-sm tw:w-48 tw:mb-5">
                            Select a Pixel and a Facebook Page to proceed with launching your campaigns.
                        </p>
                        <Button
                            onClick={navigateToSettings}
                            className="tw:bg-[#2450BF] tw:hover:bg-[#2860EE] tw:!p-0 tw:w-[196px] tw:text-white tw:py-2 tw:rounded tw:flex tw:items-center tw:gap-2"
                        >
                            <ArrowRightIcon className="tw:w-6 tw:h-6" />
                            Go to Media Settings
                        </Button>
                    </div>
                    <div className="tw:border-l">
                        <div className="tw:p-6">
                            <div className="tw:h-[429px] tw:w-[229px] tw:flex tw:items-center tw:justify-center">
                                <Funnel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw:px-6 tw:py-5 tw:border-t tw:border-border tw:flex tw:!items-center tw:justify-end">
                <Button disabled className="tw:w-40">
                    Next
                </Button>
            </div>
        </div>
    )
}

export default EmptyWizard
